export function limitRand(rand = Math.random(), min = 0, max = 1) {
	return min + rand() * (max - min)
}

export function roundRand(rand = Math.random(), min = 0, max = 1) {
	return Math.round(limitRand(rand, min, max))
}

export function randomFromString(str) {
	const seed = xmur3(str || "default")

	// const rand = mulberry32(seed())
	const rand = sfc32(seed(), seed(), seed(), seed())

	return rand
}

/* eslint-disable no-mixed-operators */
export function mulberry32(a) {
	return function () {
		var t = (a += 0x6d2b79f5)
		t = Math.imul(t ^ (t >>> 15), t | 1)
		t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
		return ((t ^ (t >>> 14)) >>> 0) / 4294967296
	}
}

export function sfc32(a, b, c, d) {
	return function () {
		a >>>= 0
		b >>>= 0
		c >>>= 0
		d >>>= 0
		var t = (a + b) | 0
		a = b ^ (b >>> 9)
		b = (c + (c << 3)) | 0
		c = (c << 21) | (c >>> 11)
		d = (d + 1) | 0
		t = (t + d) | 0
		c = (c + t) | 0
		return (t >>> 0) / 4294967296
	}
}

export function xmur3(str) {
	for (var i = 0, h = 1779033703 ^ str.length; i < str.length; i++) {
		h = Math.imul(h ^ str.charCodeAt(i), 3432918353)
		h = (h << 13) | (h >>> 19)
	}
	return function () {
		h = Math.imul(h ^ (h >>> 16), 2246822507)
		h = Math.imul(h ^ (h >>> 13), 3266489909)
		return (h ^= h >>> 16) >>> 0
	}
}
